import React from 'react';
import PropTypes from 'prop-types';
import { Tab, Tabs } from 'react-bootstrap';
import PerSupport from './PerSupport';
import PerContract from './PerContract';
import DcaSettings from '../dca';

const PerSettings = ({ settings: { baseProducts, contracts }, businessPartners }) => (
    <Tabs id="per-tabs">
        <Tab eventKey="perSupport" title="Supports">
            <PerSupport products={baseProducts} types={contracts} />
        </Tab>
        <Tab eventKey="perContract" title="Contrats">
            <PerContract baseProducts={baseProducts} businessPartners={businessPartners} types={contracts} />
        </Tab>
        <Tab eventKey="perDca" title="DCA">
            <DcaSettings type="per" />
        </Tab>
    </Tabs>
);
PerSettings.propTypes = {
    settings: PropTypes.shape({
        baseProducts: PropTypes.shape({}),
        contracts: PropTypes.shape({}),
    }).isRequired,
    businessPartners: PropTypes.shape({}),
};

export default PerSettings;
